// extracted by mini-css-extract-plugin
export default {"scroll_to_top_button":"ScrollToTopButton_scroll_to_top_button__Mq1DJ","visible":"ScrollToTopButton_visible__R-WXh"};